import { render } from "./SelectJourney.vue?vue&type=template&id=837f1fa2&scoped=true&lang=pug"
import script from "./SelectJourney.vue?vue&type=script&lang=ts"
export * from "./SelectJourney.vue?vue&type=script&lang=ts"

import "./SelectJourney.vue?vue&type=style&index=0&id=837f1fa2&lang=css"
import "./SelectJourney.vue?vue&type=style&index=1&id=837f1fa2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-837f1fa2"

export default script